<template>
  <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
    <div class="max-w-6xl mx-auto py-10 sm:px-6 lg:px-8">
      <div class="shadow-lg bg-white rounded-lg rounded-b-none p-6">
        <div
          class="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div
            class="max-w-md w-full space-y-8">
            <div>
              <img
                class="mx-auto h-12 w-auto"
                src="/img/andVet_logo.png">
              <h2
                class="mt-6 text-center text-3xl font-extrabold text-gray-900">
                第一回<br>愛玩動物看護師 国家試験<br>オンライン模試<br>事前登録
              </h2>
            </div>

            <div
              class="rounded-md shadow-sm -space-y-px">
              <div>
                <label
                  for="email-address"
                  class="sr-only">メールアドレス</label>
                <input
                  id="email-address"
                  v-model="email"
                  name="email"
                  type="email"
                  autocomplete="email"
                  required
                  class="appearance-none rounded-none relative block w-full px-3 py-2 border-4 border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="メールアドレス">
              </div>
              <div
                v-if="!errorsObj.email.length == 0">
                <p
                  v-for="error in errorsObj.email"
                  :key="error.index"
                  class="text-sm text-red-500 tracking-widest">
                  {{ error }}
                </p>
              </div>
              <div>
                <label
                  for="password"
                  class="sr-only">パスワード</label>
                <input
                  id="password"
                  v-model="password"
                  name="password"
                  type="password"
                  autocomplete="current-password"
                  required
                  class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="パスワード(6文字以上)">
              </div>
              <div
                v-if="!errorsObj.password.length == 0">
                <p
                  v-for="error in errorsObj.password"
                  :key="error.index"
                  class="text-sm text-red-500 tracking-widest">
                  {{ error }}
                </p>
              </div>

              <div>
                <label
                  for="confirmationPassword"
                  class="sr-only">確認用パスワード</label>
                <input
                  id="confirmationPassword"
                  v-model="confirmationPassword"
                  name="confirmationPassword"
                  type="password"
                  autocomplete="current-password"
                  required
                  class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="確認用パスワード">
              </div>
              <div
                v-if="!errorsObj.confirmationPassword.length <= 0">
                <p
                  v-for="error in errorsObj.confirmationPassword"
                  :key="error.index"
                  class="text-sm text-red-500 tracking-widest">
                  {{ error }}
                </p>
              </div>
            </div>
            <div>
              <button
                class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click="registerCustomer">
                <span
                  class="absolute left-0 inset-y-0 flex items-center pl-3">
                  <!-- Heroicon name: solid/lock-closed -->
                  <svg
                    class="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true">
                    <path
                      fill-rule="evenodd"
                      d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                      clip-rule="evenodd" />
                  </svg>
                </span>
                登録実行
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import { ref, reactive } from 'vue'
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth'
import REGISTER_ERROR_MESSAGES from '@/Constants/registerErrors'
import firebaseApp from '@/Constants/configFirebase'

const emailReg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}.[A-Za-z0-9]{1,}$/
const auth = getAuth(firebaseApp)
const email = ref('')
const password = ref('')
const confirmationPassword = ref('')

const errorsObj = reactive({
  isExistsErrors: false,
  email: [],
  password: [],
  confirmationPassword: [],
})

// エラーオブジェクトを初期化
const initErrors = () => {
  Object.keys(errorsObj).forEach((key) => {
    if (key === 'isExistsErrors') {
      errorsObj[key] = false
      return
    }

    errorsObj[key] = []
  })
}

const checkedErrors = () => {
  // エラーオブジェクトを初期化
  initErrors()

  // エラーをチェック（入力項目をチェック）
  if (password.value !== confirmationPassword.value) {
    errorsObj.confirmationPassword.push(REGISTER_ERROR_MESSAGES.confirmationPassword)
    errorsObj.isExistsErrors = true
  }
  if (password.value.length < 6) {
    errorsObj.password.push(REGISTER_ERROR_MESSAGES.password)
    errorsObj.isExistsErrors = true
  }
  if (!email.value.match(emailReg)) {
    errorsObj.email.push(REGISTER_ERROR_MESSAGES.email)
    errorsObj.isExistsErrors = true
  }
}

// 入力値をfirebaseに登録
const registerCustomer = () => {
  checkedErrors()

  if (!errorsObj.isExistsErrors) {
    // 新規登録
    createUserWithEmailAndPassword(auth, email.value, password.value)
      .then(async () => {
        // 確認用メール送信
        await sendEmailVerification(auth.currentUser)
          .then(() => {
            Inertia.get(route('register.completion'))
          })
          .catch((e) => {
            // eslint-disable-next-line no-alert
            alert(e)
          })
        // 確認用メール送信
      }).catch(error => {
        if (error.code === 'auth/email-already-in-use') {
          // eslint-disable-next-line no-alert
          alert('既に登録済みのメールアドレスです。')
        } else {
          // eslint-disable-next-line no-alert
          alert(error.code)
        }
      })
  }
}

</script>

<style>
  input {
    border: none;
  }
</style>
